import React, { useState } from "react";
export const TableTabs = ({
  TabHandler,
  activeTab,
  ThemeColor,
  title1,
  title2,
  title3,
  title4,
}) => {
  return (
    <div className="flex z-0">
      <div className="flex">
        <div
          id={1}
          onClick={() => TabHandler(1)}
          className={` px-3 py-2   paragraphs_font font-normal cursor-pointer rounded-tl rounded-bl
          ${ThemeColor ? "text-black card-board" : " text-white border"}
          ${
            activeTab === 1 ? (ThemeColor ? "tabs_bg-white" : "bg-balck") : ""
          }`}
        >
          {title1}
        </div>
        <div
          onClick={() => TabHandler(2)}
          className={` px-3 py-2  paragraphs_font font-normal cursor-pointer 
          ${ThemeColor ? "text-black card-board" : " text-white border"}
          
          ${
            activeTab === 2
              ? ThemeColor
                ? "tabs_bg-white text-black"
                : "bg-balck text-white"
              : ""
          }`}
        >
          {title2}
        </div>
        <div
          onClick={() => TabHandler(3)}
          className={` px-3 py-2 paragraphs_font font-normal cursor-pointer
          ${ThemeColor ? "text-black card-board" : " text-white border"}
          
          ${
            activeTab === 3
              ? ThemeColor
                ? "tabs_bg-white text-black"
                : "bg-balck text-white"
              : ""
          }`}
        >
          {title3}
        </div>
        <div
          onClick={() => TabHandler(4)}
          className={` px-3 py-2   paragraphs_font font-normal cursor-pointer rounded-tr rounded-br
          ${ThemeColor ? "text-black card-board" : " text-white border"}
          
          ${
            activeTab === 4
              ? ThemeColor
                ? "tabs_bg-white text-black "
                : "bg-balck text-white"
              : ""
          }`}
        >
          {title4}
        </div>
      </div>
    </div>
  );
};
